import { useEffect, useRef, RefObject } from "react";

/** Close/dismiss when clicking outside the referenced element. */
export function useClickOutside(ref: RefObject<HTMLElement | null>, onClickOutside: () => void) {
  // Keep callback in a ref to avoid stale closures without requiring callers to memoize
  const callbackRef = useRef(onClickOutside);
  callbackRef.current = onClickOutside;

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) callbackRef.current();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [ref]);
}
